import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, compose } from 'react-apollo';
import { Table, Input, Button, message, Card, Spin, Select } from 'antd';
import _ from 'lodash';
import IconButton from 'material-ui/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import { yearsSelectArray } from '../../utils/globals';

import MUTATION from '../../graphql/mutations/storePbaRepaymentScheduleMutation.graphql';
import QUERY from '../../graphql/queries/getCustomerPbaQuery.graphql';

const { Column } = Table;
const { Option } = Select;

class PbaRepaymentSchedule extends Component {
  state = {
    submittingForm: false,
    repayment_schedule: [],
  };

  setValue = (id, key, value) => {
    const newArr = this.state.repayment_schedule.map((entry) => {
      const newEntry = entry;
      if (entry.id === id) newEntry[key] = value;
      return newEntry;
    });
    this.setState({
      repayment_schedule: newArr,
    });
  };

  addNewEntry = () => {
    const newArr = [...this.state.repayment_schedule];

    newArr.push({
      id: (+new Date()).toString(36),
      month: null,
      year: null,
      amount: null,
    });

    this.setState({
      repayment_schedule: newArr,
    });
  };

  deleteEntry = (id) => {
    this.setState({
      repayment_schedule: _.filter(this.state.repayment_schedule, (entry) => (entry.id !== id)),
    });
  };

  runMutation = () => {
    const { pba_id } = this.props.match.params;
    const { repayment_schedule } = this.state;
    this.setState({
      submittingForm: true,
    });
    this.props.mutate({
      variables: { pba_id, repayment_schedule },
      update: (cache, { data: { newRepaymentSchedule } }) => {
        const data = cache.readQuery({
          query: QUERY,
          variables: { id: pba_id },
        });
        data.customerPba.repayment_schedule = newRepaymentSchedule;
        cache.writeQuery({ query: QUERY, variables: { id: pba_id }, data });
      },
    })
      .then(() => {
        this.setState({
          submittingForm: false,
        });
        message.success('Success!');
        this.props.history.goBack();
      })
      .catch((mutateErr) => {
        console.log(mutateErr);
        this.setState({
          submittingForm: false,
        });
        message.error(mutateErr.message);
      });
  };

  render() {
    const { loading } = this.props.data;
    if (loading) {
      return (
        <Spin size="large" />
      );
    }
    const { customerPba: { bank_name } } = this.props.data;
    const { repayment_schedule } = this.state;
    return (
      <div>
        <h2 className="page-title">Factsheet - Present Banking Arrangements: Repayment Schedule</h2>
        <Card title={bank_name} bordered={false} className="ec-card">
          <Button onClick={this.addNewEntry}>Add new schedule</Button>
          <Table dataSource={repayment_schedule} rowKey="id" bordered pagination={false} style={{ marginTop: 20, marginBottom: 20, maxWidth: 600 }} size="medium">
            <Column
              title="Month"
              key="month"
              width={150}
              render={(text, record) => (
                <Select value={record.month} style={{ width: 120 }} onChange={(value) => { this.setValue(record.id, 'month', parseInt(value, 10)); }}>
                  <Option value={1}>January</Option>
                  <Option value={2}>February</Option>
                  <Option value={3}>March</Option>
                  <Option value={4}>April</Option>
                  <Option value={5}>May</Option>
                  <Option value={6}>June</Option>
                  <Option value={7}>July</Option>
                  <Option value={8}>August</Option>
                  <Option value={9}>September</Option>
                  <Option value={10}>October</Option>
                  <Option value={11}>November</Option>
                  <Option value={12}>December</Option>
                </Select>
              )}
            />
            <Column
              title="Year"
              key="year"
              width={100}
              render={(text, record) => (
                <Select value={record.year} style={{ width: 80 }} onChange={(value) => { this.setValue(record.id, 'year', parseInt(value, 10)); }}>
                  {
                    yearsSelectArray.map((year) => (
                      <Option key={year} value={year}>{year}</Option>
                    ))
                  }
                </Select>
              )}
            />
            <Column
              title="Amount"
              key="amount"
              render={(text, record) => (
                <Input
                  type="number"
                  value={record.amount}
                  onChange={(event) => {
                    this.setValue(record.id, 'amount', event.target.value);
                  }}
                  style={{ maxWidth: 150 }}
                />
              )}
            />
            <Column
              key="actions"
              render={(text, record) => (
                <IconButton aria-label="Delete" onClick={() => { this.deleteEntry(record.id); }}>
                  <DeleteIcon />
                </IconButton>
              )}
            />
          </Table>
          <Button type="primary" onClick={this.runMutation} loading={this.state.submittingForm}>Save</Button>
        </Card>
      </div>
    );
  }
}

PbaRepaymentSchedule.getDerivedStateFromProps = (nextProps, prevState) => {
  if (nextProps.data.customerPba) {
    const propRS = nextProps.data.customerPba.repayment_schedule;
    if (_.isEqual(prevState.repayment_schedule, propRS)) {
      return null;
    }
    return {
      repayment_schedule: _.unionBy(propRS.map(({ __typename, ...entry }) => (entry)), prevState.repayment_schedule, 'id'),
    };
  }
  return null;
};

PbaRepaymentSchedule.propTypes = {
  mutate: PropTypes.func.isRequired,
  history: PropTypes.shape({
    goBack: PropTypes.func.isRequired,
  }).isRequired,
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string.isRequired,
      pba_id: PropTypes.string.isRequired,
    }).isRequired,
  }).isRequired,
  data: PropTypes.shape({
    loading: PropTypes.bool.isRequired,
    customerPba: PropTypes.shape({
      bank_name: PropTypes.string,
      repayment_schedule: PropTypes.array,
    }),
  }).isRequired,
};

export default compose(
  graphql(QUERY, {
    options: ({ match }) => ({ variables: { id: match.params.pba_id } }),
  }),
  graphql(MUTATION),
)(PbaRepaymentSchedule);



// WEBPACK FOOTER //
// ./src/pages/factsheet/PbaRepaymentSchedule.jsx